export const checksums = {
  "locales": "v3.5.0--VTMpmSmlQ_ngWpQR4uJ4tkPV49e1GrY5VSuFsn3FqZg",
  "recipes": "v3.5.0--MIwQLpAzCzhtUz2P2wCqQOe9plyY7cTXokBwIkDHPnM",
  "docs": "v3.5.0--E2okA60Xz8pucpm9HVqbwk9dizjWkfhRpFGUqeb5VGQ",
  "voixuserguide": "v3.5.0--GaPAKBie4Ay7NpdkO7owjhWvj3IP9erXygc0jGQhvaI"
}
export const checksumsStructure = {
  "locales": "MUD7PhNehZwnHfv4lK6CYcX_mXIUci-hAlafExf135k",
  "recipes": "VjS2WINwFdN-H11kp7H1EIX5ggk3PHzSIfxmNz6JnFY",
  "docs": "RQ8AoU9-lZjh12QOotexakTI8fjr8W5wIq4rljMcmFw",
  "voixuserguide": "MPDD2LdZ0t_gRfxqnhFXPSwk1GSPXM4MIpARl0W-xfc"
}

export const tables = {
  "locales": "_content_locales",
  "recipes": "_content_recipes",
  "docs": "_content_docs",
  "voixuserguide": "_content_voixuserguide",
  "info": "_content_info"
}

export default {
  "locales": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "recipes": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "name": "string",
      "layout": "string",
      "recipe": "json"
    }
  },
  "docs": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "view": "string",
      "order": "number"
    }
  },
  "voixuserguide": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "view": "string",
      "order": "number"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}